import React, { useEffect, useState } from 'react';
import { Copy } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../lib/api';

function CopyRow({ label, value, testid }) {
  const copy = () => navigator.clipboard.writeText(value).then(() => toast.success('Copied'));
  return (
    <div className="space-y-1">
      <p className="text-xs font-medium text-muted-foreground">{label}</p>
      <div className="flex items-center gap-2">
        <code className="flex-1 break-all rounded-md border bg-muted/40 px-2 py-1.5 text-xs" data-testid={`${testid}-value`}>{value}</code>
        <button type="button" onClick={copy} className="inline-flex items-center gap-1 rounded-md border px-2 py-1.5 text-xs hover:bg-muted" data-testid={`${testid}-copy`}><Copy className="h-3 w-3" />Copy</button>
      </div>
    </div>
  );
}

/** Shows the exact Google Cloud origin + redirect URI for the site the admin is on. */
export function GoogleRedirectInfo() {
  const [info, setInfo] = useState(null);
  useEffect(() => { api.request('/email-accounts/gmail/redirect-info').then(setInfo).catch(() => {}); }, []);
  if (!info) return null;
  return (
    <div className="mt-4 space-y-3 rounded-lg border border-dashed p-4" data-testid="google-redirect-info">
      <p className="text-sm font-medium">Google Cloud settings for this site</p>
      <p className="text-xs text-muted-foreground">Add both to your OAuth web client (APIs &amp; Services → Credentials). They must match exactly, with no trailing slash. Enable the Gmail, Calendar and Drive APIs.</p>
      <CopyRow label="Authorized JavaScript origin" value={info.javascript_origin} testid="google-origin" />
      <CopyRow label="Authorized redirect URI" value={info.redirect_uri} testid="google-redirect" />
    </div>
  );
}
